import { loadedStatus } from '@/lib/contexts/auth';
import getCompanyIdForRequest from '@/lib/getCompanyIdForRequest';
import xMindcloudInstance from '@/schema/xMindcloudInstance';

const local = window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1');
const staging = window.location.hostname.includes('staging');
const BASE_API = local ? `http://localhost:9800/` : staging ? `https://api-staging.mindcloud.co/` : `https://api.mindcloud.co/`;

/**
 * Make a streaming request using Server-Sent Events (SSE)
 * Follows the same patterns as apiRequest.js but for streaming responses
 */
const streamRequest = async (url, config = {}) => {
  const nonBlockingWaitToBeLoaded = () =>
    new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (loadedStatus.getIsLoaded() === false) {
          resolve(nonBlockingWaitToBeLoaded());
        } else {
          resolve();
        }
      });
    });

  await nonBlockingWaitToBeLoaded();

  const bearerToken = await window?.Clerk?.session?.getToken();
  const fixedUrl = String(String(url).match(/^https*:\/\//) ? url : `${BASE_API}${url}`);

  const companyId = getCompanyIdForRequest();
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${bearerToken}`,
    'x-mindcloud-instance': xMindcloudInstance,
    ...(config.headers || {}),
    ...(companyId ? { 'X-Company-Id': companyId } : {})
  };

  const response = await fetch(fixedUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify(config.data || {}),
    signal: config.signal
  });

  if (!response.ok) {
    let errorMessage;
    try {
      const text = await response.text();
      errorMessage = text || `HTTP error! status: ${response.status}`;
    } catch {
      errorMessage = `HTTP error! status: ${response.status}`;
    }
    throw new Error(errorMessage);
  }

  return response;
};

export default streamRequest;
